import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs">
      <ol className="flex flex-wrap items-center gap-1.5 text-foreground-500">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`} className="flex items-center gap-1.5">
              {item.path && !isLast ? (
                <Link
                  to={item.path}
                  className="hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  aria-current={isLast ? 'page' : undefined}
                  className={isLast ? 'text-foreground-800' : ''}
                >
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span className="w-3.5 h-3.5 flex items-center justify-center text-foreground-300">
                  <i className="ri-arrow-right-s-line" />
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}